import { useTheme } from "next-themes";

type PercentBarProps = {
  percent: number;
  testId?: string;
  fillColor?: string;
};

const PercentBar = ({
  percent,
  testId = "PercentBarContainer",
  fillColor = "#22c55e",
}: PercentBarProps) => {
  const { theme } = useTheme();
  const clampedPercent = Math.min(Math.max(percent, 0), 100);
  const displayPercent = Math.round(percent);

  return (
    <div
      data-testid={testId}
      id={testId}
      className="relative flex h-4 w-full items-center overflow-hidden rounded outline-1 outline-[#3D3F44] outline"
      style={{ backgroundColor: theme === "dark" ? "black" : "#DBDBDB" }}
    >
      <div
        className="absolute left-0 top-0 h-full transition-all duration-300 rounded"
        style={{
          width: `${clampedPercent}%`,
          backgroundColor: fillColor,
        }}
      />
      <span className="relative z-10 w-full text-center text-xs font-semibold text-gray-800 dark:text-white">
        {displayPercent}%
      </span>
    </div>
  );
};

export default PercentBar;
